import { dungApiThat, goiApi } from '../api/http';
import type { ApiError } from '../errors';
import { mayChuKhoaApi } from '../../mock/khoa-api';
import { mockRequest, mockState } from '../../mock/transport';
import type { ApiKeyCreate, ApiKeyCreated, ApiKeyPage } from '../../modules/khoa-api/types';

const GOC = '/api/v1/api-keys';

/** Máy chủ giả chạy **sau** nhịp chờ và các trạng thái `?mock=`: lỗi tới cùng độ trễ với lỗi thật. */
const giaLap = <T>(lam: () => T): Promise<T> => mockRequest(undefined).then(lam);

/** Trang danh sách phải có mảng `items`; thiếu là route chưa trỏ đúng service. */
const kiemTrang = (trang: ApiKeyPage): ApiKeyPage => {
  if (!Array.isArray(trang?.items)) {
    throw { code: 'INTERNAL', status: 200, message: '' } satisfies ApiError;
  }
  return trang;
};

const TRANG_RONG: ApiKeyPage = { items: [], next_cursor: null };

/**
 * Khoá API của tổ chức (G2-D1-18, ADR-0068), qua Gateway tới tenant-service.
 * `tenant_id` lấy từ token, không gửi tham số. Mỗi hàm chọn **lúc gọi** giữa
 * API thật và máy chủ giả (`mock/khoa-api.ts`).
 */
export const khoaApiRepository = {
  /** `GET /api/v1/api-keys` — mới nhất trước. `?mock=filtered-empty` trả rỗng để soát rỗng-vì-lọc. */
  danhSach: ({ limit, cursor }: { limit: number; cursor?: string }): Promise<ApiKeyPage> => {
    if (dungApiThat()) return goiApi<ApiKeyPage>(GOC, { query: { limit, cursor } }).then(kiemTrang);
    if (mockState() === 'filtered-empty') return mockRequest(TRANG_RONG);
    return mockRequest(mayChuKhoaApi.danhSach({ limit, cursor }), TRANG_RONG);
  },

  /**
   * `POST /api/v1/api-keys` — **không** gửi `Idempotency-Key`: phản hồi mang bí
   * mật chỉ hiện một lần, server không lưu để phát lại (ADR-0068 mục 3).
   */
  tao: (du: ApiKeyCreate): Promise<ApiKeyCreated> =>
    dungApiThat()
      ? goiApi<ApiKeyCreated>(GOC, { method: 'POST', body: du })
      : giaLap(() => mayChuKhoaApi.tao(du)),

  /** `DELETE /api/v1/api-keys/{id}` → `204`; gọi lại với khoá đã thu hồi vẫn `204`. */
  thuHoi: (id: string): Promise<void> =>
    dungApiThat()
      ? goiApi<void>(`${GOC}/${encodeURIComponent(id)}`, { method: 'DELETE' })
      : giaLap(() => mayChuKhoaApi.thuHoi(id)),
};
